// Which build this is, stamped at build time (vite.config.ts `define`, from scripts/build-static.sh):
// a release tag's version (platform_1.4.0 → "1.4.0"), "dev-<commit>" for builds of main, "local" otherwise.
declare const __APP_VERSION__: string;
declare const __APP_COMMIT__: string;
declare const __APP_BUILT_AT__: string;

export const APP_VERSION = __APP_VERSION__;
export const APP_COMMIT = __APP_COMMIT__.slice(0, 7);
export const APP_BUILT_AT = __APP_BUILT_AT__;

/** "v1.4.0" for releases, else the dev stamp as is ("dev-6db2d9e", "local"). */
export function versionLabel(version: string = APP_VERSION): string {
  return /^\d/.test(version) ? `v${version}` : version;
}
